import { Playground, PropsTable } from '@versionone/doc-components';
import { createComponent } from "../../../../../components/src/StyleProvider";
import { Avatar } from "../../../../../components/src/Avatar";
import { Button } from "../../../../../components/src/Button";
import { Divider } from "../../../../../components/src/Divider";
import { IconButton } from "../../../../../components/src/Button";
import { InfoIcon } from '@versionone/icons';
import { List, ListItem, ListItemText } from "../../../../../components/src/List";
import { Lozenge } from "../../../../../components/src/Lozenge";
import { Paper } from "../../../../../components/src/Paper";
import { Popover } from "../../../../../components/src/Popover";
import { SpacedGroup } from "../../../../../components/src/SpacedGroup";
import { TextField } from "../../../../../components/src/TextField";
import * as placements from "../../../../../components/src/Popover/placements";
import * as React from 'react';
export default {
  Playground,
  PropsTable,
  createComponent,
  Avatar,
  Button,
  Divider,
  IconButton,
  InfoIcon,
  List,
  ListItem,
  ListItemText,
  Lozenge,
  Paper,
  Popover,
  SpacedGroup,
  TextField,
  placements,
  React
};